<template>
  <main id="main" class="min-h-screen py-16 px-4 sm:px-6 lg:px-8 bg-background dark:bg-dark-bg text-primary dark:text-dark-text transition-colors duration-300">
    <article class="max-w-3xl mx-auto space-y-8">
      <header class="mb-10 border-b border-gray-200 dark:border-gray-700 pb-6 transition-colors duration-300">
        <h1 class="text-3xl sm:text-4xl font-heading font-bold mb-4 text-primary dark:text-dark-text transition-colors duration-300">
          {{ t('privacyPolicy.title') }}
        </h1>
        <p class="text-sm text-gray-500 dark:text-gray-400 transition-colors duration-300">
          {{ t('privacyPolicy.lastUpdated') }}
        </p>
      </header>

      <section 
        v-for="(section, index) in sections" 
        :key="index"
        class="space-y-3"
      >
        <h2 
          v-if="section.heading" 
          class="text-xl sm:text-2xl font-heading font-semibold text-accent transition-colors duration-300"
        >
          {{ section.heading }}
        </h2>
        <p class="text-base leading-relaxed text-gray-700 dark:text-gray-300 transition-colors duration-300">
          {{ section.content }}
        </p>
      </section>
    </article>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, tm } = useI18n({ useScope: 'global' });

const sections = computed(() => {
  const data = tm('privacyPolicy.sections');
  return Array.isArray(data) ? data : [];
});
</script>